import { App } from 'vue';
import { HTTP_STATUS } from '@constants/http-status';

const HttpStatusPlugin = {
  install(app: App) {
    app.provide('$httpStatus', HTTP_STATUS);
  },
};

export default HttpStatusPlugin;
